import axios from 'axios';
import { Prod01 } from '../../constants/ActionType';

// All sensitive values (DOB, DEA, license, passwords) travel in request bodies, never in URLs.
const base = `${Prod01}/personnel`;

export const targetOf = (person) => ({ kind: person.kind, id: person.id, email: person.email });

export const errMsg = (e) => e?.response?.data?.message || e.message;

export const personnelApi = {
  access: () => axios.get(`${base}/access`).then((r) => r.data),
  directory: (params) => axios.get(base, { params }).then((r) => r.data),
  profile: (kind, id) => axios.get(`${base}/${kind}/${id}`).then((r) => r.data),
  // `target` is the profile on screen ({ kind, id, email }); the server rejects writes that do not match it.
  editCoordinator: (kind, id, body, target) => axios.patch(`${base}/${kind}/${id}`, { ...body, target }).then((r) => r.data),
  setStatus: (kind, id, body, target) => axios.post(`${base}/${kind}/${id}/status`, { ...body, target }).then((r) => r.data),
  resetPassword: (kind, id, body, target) =>
    axios.post(`${base}/${kind}/${id}/password`, { ...body, target }).then((r) => r.data),
  setRole: (kind, id, role, target) => axios.put(`${base}/${kind}/${id}/role`, { role, target }).then((r) => r.data),
  createCredential: (kind, id, body, target) =>
    axios.post(`${base}/${kind}/${id}/credentials`, { ...body, target }).then((r) => r.data),
  updateCredential: (credentialId, body) => axios.patch(`${base}/credentials/${credentialId}`, body).then((r) => r.data),
  reveal: (credentialId, field) => axios.post(`${base}/credentials/${credentialId}/reveal`, { field }).then((r) => r.data),
  alerts: () => axios.get(`${base}/credentials/alerts`).then((r) => r.data),
  lookupNpi: (npi) => axios.post(`${base}/npi/lookup`, { npi }).then((r) => r.data),
  createOptions: () => axios.get(`${base}/create-options`).then((r) => r.data),
  create: (body) => axios.post(base, body).then((r) => r.data),
  resendInvite: (kind, id, target) => axios.post(`${base}/${kind}/${id}/invite`, { target }).then((r) => r.data),
};

export const ALERT_STYLES = {
  expired: { bg: '#b91c1c', label: 'Expired' },
  d7: { bg: '#dc2626', label: '≤ 7 days' },
  d30: { bg: '#ea580c', label: '≤ 30 days' },
  d60: { bg: '#ca8a04', label: '≤ 60 days' },
};

export const AlertBadge = ({ level, days }) => {
  const s = ALERT_STYLES[level];
  if (!s) return null;
  const text = level === 'expired' ? `Expired${days != null ? ` ${Math.abs(days)}d ago` : ''}` : `${s.label}${days != null ? ` (${days}d)` : ''}`;
  return (
    <span style={{ background: s.bg, color: '#fff', padding: '2px 7px', borderRadius: 10, fontSize: 12, whiteSpace: 'nowrap' }}>
      {text}
    </span>
  );
};
